const steps = [
  {
    num: '01',
    icon: 'ri-phone-line',
    title: '상담 신청',
    desc: '전화 또는 온라인으로 무료 상담 신청. 24시간 언제든지 연락 가능합니다.',
    color: 'from-[#03C75A] to-[#00A843]',
  },
  {
    num: '02',
    icon: 'ri-file-list-3-line',
    title: '서류 제출',
    desc: '신분증, 카드 사본 등 최소한의 서류만 비대면으로 간편하게 제출합니다.',
    color: 'from-[#00A843] to-[#008F38]',
  },
  {
    num: '03',
    icon: 'ri-search-eye-line',
    title: '심사 진행',
    desc: '전문 상담사가 카드 한도 및 조건을 신속하게 심사합니다. 당일 처리 가능.',
    color: 'from-[#008F38] to-[#007730]',
  },
  {
    num: '04',
    icon: 'ri-checkbox-circle-line',
    title: '승인 완료',
    desc: '심사 완료 후 즉시 승인 안내 연락을 드리며 최종 조건을 확인합니다.',
    color: 'from-[#007730] to-[#005F25]',
  },
  {
    num: '05',
    icon: 'ri-bank-line',
    title: '입금 완료',
    desc: '승인된 금액이 지정 계좌로 신속하게 입금됩니다. 전 과정 비대면 진행.',
    color: 'from-[#005F25] to-[#004D1E]',
  },
];

export default function ProcessSection() {
  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="process" className="py-12 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <span className="inline-block bg-[#03C75A]/10 text-[#03C75A] text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 rounded-full mb-3 sm:mb-4">
            진행절차
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-black text-gray-900 mb-3 sm:mb-4">방문대출가능/비대면대출가능</h2>
        </div>

        {/* Steps - Desktop */}
        <div className="hidden lg:flex items-start gap-0 mb-12">
          {steps.map((step, idx) => (
            <div key={step.num} className="flex items-start flex-1 relative">
              <div className="flex-1 flex flex-col items-center text-center px-3">
                <div className={`w-16 h-16 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center mb-4`}>
                  <span className="text-white font-black text-lg">{step.num}</span>
                </div>
                <div className="w-12 h-12 flex items-center justify-center bg-[#03C75A]/10 rounded-xl mb-3">
                  <i className={`${step.icon} text-xl text-[#03C75A]`}></i>
                </div>
                <h3 className="text-base font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-xs text-gray-500 leading-relaxed">{step.desc}</p>
              </div>
              {idx < steps.length - 1 && (
                <div className="absolute top-7 right-0 translate-x-1/2 z-10">
                  <i className="ri-arrow-right-s-line text-2xl text-[#03C75A]"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Steps - Mobile & Tablet */}
        <div className="lg:hidden space-y-3 sm:space-y-4 mb-8 sm:mb-12">
          {steps.map((step) => (
            <div key={step.num} className="flex items-start gap-3 sm:gap-4 bg-[#f7f9fa] rounded-xl p-4 sm:p-5">
              <div className={`w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center shrink-0`}>
                <span className="text-white font-black text-sm">{step.num}</span>
              </div>
              <div>
                <h3 className="font-bold text-gray-900 mb-1 text-sm sm:text-base">{step.title}</h3>
                <p className="text-xs sm:text-sm text-gray-500 leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Notice */}
        <div className="bg-[#f7f9fa] rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 text-center sm:text-left">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-[#03C75A]/10 rounded-xl shrink-0">
              <i className="ri-information-line text-xl text-[#03C75A]"></i>
            </div>
            <div>
              <p className="font-bold text-gray-900 text-sm">전 과정 비대면 · 당일 처리 가능</p>
              <p className="text-xs text-gray-500">방문 없이 전화 한 통으로 입금까지 진행됩니다</p>
            </div>
          </div>
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); handleClick('#contact'); }}
            className="bg-[#03C75A] text-white font-bold px-5 sm:px-6 py-2.5 sm:py-3 rounded-xl hover:bg-[#00A843] transition-colors cursor-pointer whitespace-nowrap w-full sm:w-auto text-center text-sm sm:text-base"
          >
            지금 바로 신청하기
          </a>
        </div>
      </div>
    </section>
  );
}
